export default __webpack_public_path__ + "static/media/carousel-img-5.3fa514a6.webp";